const getWSNotificationsURL = ({ customerAccountId, userURN, accountRegion }) => {
  const deploymentTarget = process.env.DEPLOYMENT_TARGET || 'prod';
  let baseURL = '';

  switch (deploymentTarget) {
    case 'dev':
    case 'alpha':
      baseURL = `https://ws-notification.workload.${accountRegion}.dev-cloudone.trendmicro.com`;
      break;
    case 'staging':
      baseURL = `https://c1ws-notification-staging.workload.${accountRegion}.staging-cloudone.trendmicro.com`;
      break;
    case 'prod':
    default:
      baseURL = `https://c1ws-notification.${accountRegion}.cloudone.trendmicro.com`;
      break;
  }
  return `${baseURL}/api/v1/notifications?customerAccountId=${customerAccountId}&userURN=${userURN}`;
};
// Calls the WS Notifications API to get the notifications for the user's account
export const getWSNotifications = async ({
  c1Token,
  userURN,
  customerAccountId,
  accountRegion,
}) => {
  try {
    const response = await fetch(
      getWSNotificationsURL({ customerAccountId, userURN, accountRegion }),
      {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          'api-version': 'v1',
          Authorization: `Bearer ${c1Token}`,
        },
      }
    );

    if (response.ok) {
      const { Items: items = [], Count: count = 0 } = await response.json();
      return { count, notifications: items };
    } else {
      console.error(`getWSNotifications(): ${response?.status} ${response?.statusText}`);
      throw { code: response?.status };
    }
  } catch (error) {
    console.error(`getWSNotifications(): Failed`, error);
    throw { code: 503 };
  }
};
